






















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class extends Vue {
    @Prop(String) amount!: string;
    @Prop(String) select!: string;
    output = this.amount;

    mounted() {
        console.log(this.output);
    }

    storeOutput(event: MouseEvent) {
        const button = event.target as HTMLButtonElement;
        const input = button.textContent as string;
        //第一步初始值为零
        if (this.output.length >= 16) {
            return;//最多十六位
        }

        if (this.output === '0') {
            if (input === '0') {
                return;
            } else if ('123456789'.indexOf(input) >= 0) {
                this.output = input;
                this.$emit('update:amount', (this.output));


            }
            if (input === '.') {
                this.output += input;
                this.$emit('update:amount', (this.output));

            }
        } else if (this.output.indexOf('.') >= 0 && input === '.') {

            return;
        } else {
            this.output += input;
            this.$emit('update:amount', (this.output));

        }


    }

    clear() {
        this.output = '';
    }

    deleteOutput() {
        this.output = this.output.slice(0, -1);
        this.$emit('update:amount', (this.output));

    }

    ok() {
        this.$emit('submit');
        this.clear();


    }
}
